const apiUrl = 'https://jservice.io/api/';

export default apiUrl;
